/**
 * React Query Keys for Collaborative Lists
 */

import { GetRestaurantsParams } from '@/types/collaborative/collaborativeList';

export const collaborativeKeys = {
  all: ['collaborative'] as const,

  // List queries
  lists: () => [...collaborativeKeys.all, 'lists'] as const,

  // List details
  details: () => [...collaborativeKeys.all, 'detail'] as const,
  detail: (urlKey: string) => [...collaborativeKeys.details(), urlKey] as const,

  // Restaurants in a list
  restaurantsBase: (urlKey: string) =>
    [...collaborativeKeys.detail(urlKey), 'restaurants'] as const,
  restaurants: (urlKey: string, params?: GetRestaurantsParams) =>
    [...collaborativeKeys.restaurantsBase(urlKey), params] as const,

  // Voting
  voting: (urlKey: string) => [...collaborativeKeys.detail(urlKey), 'voting'] as const,
  votingResults: (urlKey: string) => [...collaborativeKeys.voting(urlKey), 'results'] as const,
  votingHistory: (urlKey: string) => [...collaborativeKeys.voting(urlKey), 'history'] as const,

  // Activity
  activity: (urlKey: string) => [...collaborativeKeys.detail(urlKey), 'activity'] as const,
} as const;
